import { Module } from 'vuex';
import { RootState } from './index';

export interface UsuarioState {
  usuarioId: string | null;
  imagemUrl: string | null;
}

const state: UsuarioState = {
  usuarioId: null,
  imagemUrl: null,
};

const mutations = {
  SET_USUARIO(state: UsuarioState, payload: { usuarioId: string; imagemUrl: string }) {
    state.usuarioId = payload.usuarioId;
    state.imagemUrl = payload.imagemUrl;
  },
  UPDATE_IMAGEM(state: UsuarioState, imagemUrl: string) {
    state.imagemUrl = imagemUrl;
  },
  CLEAR_USUARIO(state: UsuarioState) {
    state.usuarioId = null;
    state.imagemUrl = null;
  },
};

const actions = {
  adicionarUsuario({ commit }, payload: { usuarioId: string; imagemUrl: string }) {
    commit('SET_USUARIO', payload);
  },
  atualizarImagem({ commit }, imagemUrl: string) {
    commit('UPDATE_IMAGEM', imagemUrl);
  },
  selecionarUsuario({ state }) {
    return { usuarioId: state.usuarioId, imagemUrl: state.imagemUrl };
  },
  removerUsuario({ commit }) {
    commit('CLEAR_USUARIO');
  },
};

const getters = {
  usuarioId: (state: UsuarioState): string | null => state.usuarioId,
  imagemUrl: (state) => {
    if (!state.imagemUrl) return null;
    // Se já for uma URL completa, retorna direto
    if (state.imagemUrl.startsWith('http')) return state.imagemUrl;
    // Se for só a chave, monta a URL do backend
    return `https://localhost:7087/ArquivoS3/obter-url-imagem-usuario?chave=${state.imagemUrl}`;
  },
  usuario: (state: UsuarioState) => ({ usuarioId: state.usuarioId, imagemUrl: state.imagemUrl }),
};

export const usuario: Module<UsuarioState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
